export const projectData = [
  {
    id: 0,
    name: 'Blog Website',
    link: 'https://bambinakatarina.netlify.com',
    img: 'https://digitalmarketingauthors.com/wp-content/uploads/2018/01/Blog-intro.jpg',
    github: 'https://github.com/JamshedHabibi/melbourne-tours',
    js: 'TypeScript',
    react: 'React/Gatsby',
    googleFirebase: 'GraphQL',
    css: 'Emotion CSS-in-JS',
  },
  {
    id: 1,
    name: 'Melbourne Tours',
    link: 'https://melbourne-tours.netlify.com',
    img: 'https://www.tripsavvy.com/thmb/jO1lBr8jp3HVVuAyGIf3ChGhsts=/1428x1428/smart/filters:no_upscale()/cityscape-of-melbourne-city-of-australia-during-the-sunset--873409300-8db98cef20b44200abfb339188d801f7.jpg',
    github: 'https://github.com/JamshedHabibi/melbourne-tours',
    react: 'React',
    contextApi: 'Context API',
    googleFirebase: 'Google Firebase',
    css: 'CSS',
    bootstrap: 'React Semantic UI',
  },
  {
    id: 2,
    name: 'Real Estate Application',
    link: 'https://jamsheds-real-estate.netlify.com',
    img: 'https://michele.blog/wp-content/uploads/2017/02/handing-over-house-key.jpg',
    github: 'https://github.com/JamshedHabibi/real-estate',
    react: 'React',
    contextApi: 'Context API',
    css: 'Styled-Components',
    bootstrap: 'Bootstrap',
  },
  {
    id: 3,
    name: 'E-Commerce Bike Shop',
    link: 'https://jamsheds-ebike-shop.netlify.com',
    img: 'https://img.archiexpo.com/images_ae/photo-g/153471-12012713.jpg',
    github: 'https://github.com/JamshedHabibi/react-bike-store',
    react: 'React',
    contextApi: 'Context API',
    css: 'Styled-Components',
    bootstrap: 'Bootstrap',
  },
  {
    id: 4,
    name: 'Registration Form',
    link: 'https://jamsheds-registration-form.netlify.com',
    img: 'https://www.thebalancesmb.com/thmb/tBT83K1QjTZQech2ETDJ0-dLqSU=/3840x3840/smart/filters:no_upscale()/GettyImages-608156065-572f6d393df78c038e42aaed.jpg',
    github: 'https://github.com/JamshedHabibi/registration-form',
    js: 'JavaScript',
    css: 'CSS',
  },
  {
    id: 5,
    name: 'Cool Stopwatch',
    link: 'https://jamsheds-stopwatch.netlify.com',
    github: 'https://github.com/JamshedHabibi/stopwatch',
    img: 'https://s.abcnews.com/images/US/time-change-02-ap-jc-180307_1x1_608.jpg',
    react: 'React',
    contextApi: 'Context API',
    css: 'CSS',
    bootstrap: 'Bootstrap',
  },
];

export const skills = [
  {
    name: 'JavaScript',
    img: 'https://d2908q01vomqb2.cloudfront.net/0716d9708d321ffb6a00818614779e779925365c/2020/12/11/ts-logo-512.png',
  },
  {
    name: 'JavaScript',
    img: 'https://d2eip9sf3oo6c2.cloudfront.net/tags/images/000/000/205/square_280/javascriptlang.png',
  },
  {
    name: 'React',
    img: 'https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png',
  },
  {
    name: 'HTML',
    img: 'https://cdn0.iconfinder.com/data/icons/HTML5/512/HTML_Logo.png',
  },
  {
    name: 'CSS',
    img: 'https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_960_720.png',
  },
  {
    name: 'NGINX',
    img: 'https://iconape.com/wp-content/png_logo_vector/nginx.png',
  },
  {
    name: 'Git Version Control',
    img: 'https://uysalmustafa.com/wp-content/uploads/2016/11/git-logo-1.png',
  },
  {
    name: 'Jest',
    img: 'https://digital.ai/sites/default/files/pictures/styles/maxwidth_300/public/pt_logos/jest.png?itok=dI0IDX4S',
  },
  {
    name: 'Bootstrap',
    img: 'https://suavesol.net/wp-content/uploads/2019/06/bootstrap.png',
  },
  {
    name: 'JQuery',
    img: 'http://pluspng.com/img-png/jquery-logo-png--800.gif',
  },
];
